const shape = {
  borderRadius: 0,
};

export { shape };
